import { create } from 'zustand';

/**
 * UI-only store for authentication UI state
 * Separates UI state from server state (handled by React Query)
 */
interface AuthUIState {
  // Core UI state
  isInitialized: boolean; // Tracks if auth has been initialized at least once
  authModalIsOpen: boolean;
  authActiveTab: 'login' | 'signup';
  
  // Password validation UI - independent from API calls
  passwordFocused: boolean;

  // UI state methods
  setInitialized: (initialized: boolean) => void;
  openAuthModal: () => void;
  closeAuthModal: () => void;
  setAuthActiveTab: (tab: 'login' | 'signup') => void;
  setPasswordFocused: (focused: boolean) => void;
}

export const useAuthUIStore = create<AuthUIState>((set) => ({
  isInitialized: false,
  authModalIsOpen: false,
  authActiveTab: 'login',
  passwordFocused: false,

  setInitialized: (isInitialized: boolean) => set({ isInitialized }),
  openAuthModal: () => set({ authModalIsOpen: true }),
  closeAuthModal: () => set({ authModalIsOpen: false }),
  setAuthActiveTab: (tab: 'login' | 'signup') => set({ authActiveTab: tab }),
  setPasswordFocused: (passwordFocused: boolean) => set({ passwordFocused }),
}));